import React from 'react';
import { FormikProps } from 'formik';
import ATMLoadingButton from 'src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton';
import ATMTextField from 'src/components/UI/atoms/formFields/ATMTextField/ATMTextField';
import ATMSelect from 'src/components/UI/atoms/formFields/ATMSelect/ATMSelect'; 
import { PaymentModeFormValue } from 'src/models/PaymentMode.model';
import { handleValidNumber2 } from 'src/utils/formUtils/ValidNumber';

type Props = {
    formikProps: FormikProps<PaymentModeFormValue>;
    onClose: () => void;
    formType: "ADD" | "EDIT";
};

const PaymentModeForm = ({ formikProps, onClose, formType }: Props) => {
    const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;
    const typeOptions = [
        { label: 'Physical', value: 'PHYSICAL' },
        { label: 'Virtual', value: 'VIRTUAL' },
    ];

    return (
        <div className='p-4 flex flex-col gap-6'>
            <div className='flex justify-between items-center'>
                <div className='text-xl font-medium'>
                    {formType === "ADD" ? "Add Payment Mode" : "Update Payment Mode"}
                </div>
                <button type='button' className='hover:bg-hover' onClick={onClose}>
                    Cancel
                </button>
            </div>

            <div className='flex flex-col gap-4'>
                {/* Type Selector */}
                <div>
                    <ATMSelect
                        name='type'
                        label='Type'
                        options={typeOptions}
                        value={typeOptions.find(opt => opt.value === values.type)}
                        onChange={(option: any) => {
                            setFieldValue('type', option.value);
                            setFieldValue('name', '');
                            setFieldValue('value', '');
                        }}
                        onBlur={handleBlur}
                    />

                </div>



                {/* Description */}
                <div>
                    <ATMTextField
                        name='name'
                        value={values.name}
                        onChange={(e) => setFieldValue('name', e.target.value)}
                        label='Name'
                        onBlur={handleBlur}
                    />
                </div>

                {/* Value field — only for physical */}
                {values.type === 'PHYSICAL' && (
                    <div>
                        <ATMTextField
                            name='value'
                            value={values.value}
                            onChange={(e) => handleValidNumber2(e) && setFieldValue('value', e.target.value)}
                            label='Value'
                            onBlur={handleBlur}
                        />
                    </div>
                )}
            </div>

            <div>
                <ATMLoadingButton isLoading={isSubmitting} type='submit'>
                    Save
                </ATMLoadingButton>
            </div>
        </div>
    );
};

export default PaymentModeForm;
